
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emprestimo-consignado",
      function () {
        return require("private-next-pages/emprestimo-consignado/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emprestimo-consignado"])
      });
    }
  